// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import DirectUploadController from "./direct_upload_controller"
application.register("direct-upload", DirectUploadController)

import DiscountCodeController from "./discount_code_controller"
application.register("discount-code", DiscountCodeController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import OrderFormController from "./order_form_controller"
application.register("order-form", OrderFormController)

import PhotoUploadController from "./photo_upload_controller"
application.register("photo-upload", PhotoUploadController)

import ShippingAddressController from "./shipping_address_controller"
application.register("shipping-address", ShippingAddressController)

import ZipDownloadController from "./zip_download_controller"
application.register("zip-download", ZipDownloadController)
